


export class Player {
	id:       string
	nickname: string

	
	constructor (id:string, nickname:string) {
		this.id       = id
		this.nickname = nickname
	}


	static Hydrate (obj:any) : Player {
		return new Player(obj.id, obj.nickname)
	}
}